// extracted by mini-css-extract-plugin
module.exports = {"featureTextOnly":"FeatureTextOnly_featureTextOnly__40D6j","featureTextOnlyCopy":"FeatureTextOnly_featureTextOnlyCopy__dRpKN"};